var Cookies = require('js-cookie');
(function($, window) {
    "use strict";

    var inPreview = document.location.href.indexOf('cmsPreview') >= 0;

    $(function() {

        var loaded = false;
        var $navItem, $navContainer, $homePageNavLink, $mainContent;
        var inHomePage = true;

        window.mobileFrontPage = {
            init: function (json) {
                $navContainer = $('[data-container="navigation"]');
                $homePageNavLink =  $('#mainNav1 li:first');
                $mainContent = $('#tp-content');

                // add a link for the front page in the navigation
                this.buildNav(json);
                if (inHomePage) {
                    this.createFrontPage(json);
                }
            },

            buildNav: function (json) {
                if ($navItem && $navItem.length) {
                    return;
                }

                var currentPageId;
                var pageId = require('jimdoData') && require('jimdoData').pageId ? require('jimdoData').pageId.toString() : false;
                $navContainer = $navContainer.length ? $navContainer : false;

                // if we found navigation items. take the first to add nav item
                if ($homePageNavLink.length) {
                    this.addToNav(json);

                    if (!$homePageNavLink.attr('id')) {
                        return;
                    }
                    // wish we had a better way to determinate if we are in the homepage
                    currentPageId = $homePageNavLink.attr('id').split('-')[3];
                    // if the page id is the first in navigation - we are in the homepage
                    inHomePage = currentPageId === pageId;
                }
            },

            createFrontPage: function (json) {
                if (Cookies.get("mobileFrontPageClosed") && !inPreview) {
                    return;
                }

                window.frontPageData = json;
                // to prevent flickering when removing content and adding it back, we save the old one and remove it only after added the new one
                var oldFpContent = $('</span>');
                if (this.frontPageContent) {
                    oldFpContent = $(this.frontPageContent);
                }


                this.frontPageContent = this.createContent(json);
                this.dropContent(this.frontPageContent);
                oldFpContent.remove();
                this.hideContent();
                if (inPreview && !loaded) {
                    this.previewMode(this.frontPageContent);
                    loaded = true;
                }


                // we have to use query selector and not the cobntent object for the jqurey "live" to work
                $('.cc-m-mf-wrapper .cc-m-mf-close').on('click', function () {
                    this.hideFrontPage();
                    Cookies.set("mobileFrontPageClosed", 1, {expires: 365 });
                }.bind(this));

            },

            hideContent: function () {
                $mainContent.hide();
            },

            showFrontPage: function () {
                if (this.frontPageContent) {
                    $(this.frontPageContent).show();
                    this.hideContent();
                } else if (window.frontPageData) {
                    this.createFrontPage(window.frontPageData);
                } else {
                    return;
                }
                $('nav').css('display', 'none');
            },

            hideFrontPage: function () {
                if (this.frontPageContent) {
                    $(this.frontPageContent).hide();
                }
                $mainContent.show();
            },

            closeFrontPageLayer: function () {
                $(this.frontPageContent).remove();
                $mainContent.show();
            },

            dropContent: function (html) {
                $(html).insertAfter($('nav')[0]);
            },

            createContent: function (json) {
                var data = json.params ? json.params : json,
                    closeButtonText = json.text ? json.text.close : 'close';
                var wrapper = $('<div class="cc-m-mf-wrapper"/>').append("<a href='javascript:;' class='cc-m-mf-close' title=' " + closeButtonText + " '>" + closeButtonText + "</a>");
                for (var item in data) {
                    var row = data[item].txt ? $('<div class="cc-sa-mobile-frontpage-item"/>').addClass(data[item].cls) : null,
                        label = data[item].label ? $('<div class="cc-sa-mf-label cc-sa-mf-label-icon">').html(data[item].label) : '',
                        //encodedText = this.htmlencode(data[item].txt).replace(/(\r\n|\n|\r)/gm, "<br/>"),
                        text = data[item].protocol ? this.createLink(data[item]) : $('<span>').append(data[item].txt.replace(/(\r\n|\n|\r)/gm, "<br/>"));

                    if (row) {
                        row.append(label).append(text);
                        wrapper.append(row);
                    }
                }
                return wrapper;
            },

            createLink: function (json) {
                var content = json.txt;
                if (json.img) {
                    content = content + '<img src="https://maps.googleapis.com/maps/api/staticmap?center=' + json.txt + '&zoom=13&size=' + this.getMapSize() + '&sensor=false"';
                }
                return '<a href="' + json.protocol + json.url + '">' + content + '</a>';
            },

            previewMode: function () {
                $('.cc-m-mf-wrapper a').live('click', function (e) {
                    e.preventDefault();
                    $('.cc-sa-mobile-tooltip').remove();
                    var text = $(this).attr('href').replace('++', '');

                    var tip = this.tip = $('<div/>').html(text).addClass('cc-sa-mobile-tooltip');

                    $(this.tip).insertBefore(e.target);

                    window.closeTip = function (tip) {
                        $(tip).remove();
                    };
                    window.setTimeout(function () {
                        window.closeTip(tip);
                    }, 3000);

                });

                $('html, body').animate({
                    scrollTop: $(this.frontPageContent).offset().top
                }, 2000);

            },

            addToNav: function (json) {

                var self = this,
                // TODO remove the "info page" after all websites are updated (migration)
                    navigationName = json.text ? json.text.navigationName : 'info page';
                $navItem = $('<li>').html('<a>' + navigationName + '</a>');
                $navItem.on('click', function () {
                    Cookies.remove("mobileFrontPageClosed");
                    self.showFrontPage();
                });
                $navItem.insertBefore($homePageNavLink);
            },

            getMapSize: function () {
                var w = $(window).width();
                // the content is 92% and has a padding of 3% so its 86%
                return parseInt(86 / 100 * w, 10) + 'x' + parseInt(w / 2, 10);
            }

        };

    });

    if (!inPreview) {
        $(function() {
            if (window.frontPageData) {
                window.mobileFrontPage.init(window.frontPageData);
            }
        });
        return;
    }

    // siteadmin mode:
    window.mobilePreview = window.mobilePreview ? window.mobilePreview : {};

    window.mobilePreview.frontpage = {
        init: function () {
            return this;
        },

        initFrontPage : function (data){
            $(function(){
                window.mobileFrontPage.init(data);
            });
        },

        disableFrontPage : function (){
            window.mobileFrontPage.hideFrontPage();
        },

        hideAd: function(){
            window.location.hash = 'noAd';
            $('#adFrame').hide();
        }
    };


})(require('jquery'), window);



/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/js/web/mobile/mobileFrontPage.js
 ** module id = 3803
 ** module chunks = 100
 **/